(function (ng) {
    /// <summary> The address service that retrieves information about states and countries.
    /// </summary>
    ng.module('evo.Shared.Services').factory('regionService', ['$http', '$q', 'REGION_SERVICE_BASE',
        function ($http, $q, REGION_SERVICE_BASE) {
            var regionsByCountry = {};
            var countries;
            var cityRegions = {};
            return {
                fetchCityRegion: function (country, postalCode) {
                    return $q(function (resolve, reject) {
                        if (cityRegions[country] && cityRegions[country][postalCode]) {
                            resolve(cityRegions[country][postalCode]);
                        } else {
                            $http.get(REGION_SERVICE_BASE + 'fetch-city-region', { params: { countryCode: country, postalCode: postalCode } }).then(function (result) {
                                cityRegions[country] = {};
                                cityRegions[country][postalCode] = result.data;
                                resolve(result.data);
                            });
                        }
                    });
                },
                fetchRegionsByCountry: function (country) {
                    return $q(function (resolve, reject) {
                        if (regionsByCountry[country]) {
                            resolve(regionsByCountry[country]);
                        } else {
                            $http.get(REGION_SERVICE_BASE + 'fetch-by-country', { params: { countryCode: country } }).then(function (result) {
                                regionsByCountry[country] = result.data;
                                resolve(result.data);
                            });
                        }
                    });
                },
                fetchCountries: function () {
                    return $q(function (resolve, reject) {
                        if (countries && countries.length) {
                            resolve(countries);
                        } else {
                            return $http.get(REGION_SERVICE_BASE + 'fetch-countries').then(function (result) {
                                countries = result.data;
                                resolve(result.data);
                            });
                        }
                    });
                }
            };
        }
    ]);
})(angular);